import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "aicon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createBlock("img", {
        src: `img/${ item }.png`,
        style: `width: ${ Math.random() * 7 + 5 }vw; filter: blur(${ Math.random() * 0.5 }vw); margin: ${ Math.random() * 30 - 10 }vh 0 0 ${ Math.random() * 30 - 15 }vw; animation: triangle ${ Math.random() * 10 + 40 }s ${ Math.random() * 3 }s ease infinite;`,
        alt: "",
        key: index
      }, null, 12, ["src"]))
    }), 128))
  ]))
}